<template>
  <notifications
    animation-type="velocity"
    group="kmb-notifications"
    :animation="animation"
    :duration="4200"
    :width="315"
    position="bottom left">
    <template slot="body" scope="props">
      <NotificationBody
        :config="props"
        :description="props.item.data.description"
        :first-action="props.item.data.firstAction"
        :second-action="props.item.data.secondAction" />
    </template>
  </notifications>
</template>

<script>
import NotificationBody from '@/shared/components/notifications/NotificationBody';

export default {
  data() {
    return {
      animation: {
        enter(element) {
          const height = element.clientHeight;

          return {
            opacity: [1, 0],
            translateY: [0, height],
            scale: [1, 0.2],
          };
        },
        leave: {
          opacity: 0,
          height: 0,
        },
      },
    };
  },
  components: {
    NotificationBody,
  },
};
</script>



// WEBPACK FOOTER //
// NotificationContainer.vue?befeb50e